/* eslint-disable no-undef */
import $ from 'jquery';
import { Utils } from './utils';
import "datatables.net";

export class Downloads {
    private readonly _container: JQuery;

    public constructor() {
        this._container = $('.view-intranet-documentos-tecnicos');
        if (this._container.length === 0) {
            return;
        }

        this._initDatatable();
        this._addEventListeners();
    }

    private _addEventListeners() {
        this._container.on('click', '.acciones .botonAccion', this._onButtonActionClick.bind(this));
        $('body').on('click', '.select_all', this._onSelectAllClick.bind(this));
        $('body').on('click', 'li:not(.all) input', this._onOptionClick.bind(this));
    }

    private _initDatatable() {
        const options = {
            responsive: true,
            paging: false,
            ordering: false,
            info: false,
            searching: false,
            autoWidth: true,
            destroy: true,
        };

        this._container.find('table').DataTable(options);
    }

    private _onButtonActionClick(e: JQuery.ClickEvent) {
        e.stopPropagation();
        var element = $(e.currentTarget);
        var currentContainer = element.parent();
        var isVisible = currentContainer.hasClass('isVisible');

        currentContainer.removeClass('active isVisible');
        if (!isVisible) {
            currentContainer.addClass('active isVisible');
        }
    }

    private _onSelectAllClick(e: JQuery.ClickEvent) {
        const target = $(e.currentTarget);
        const buttons = target.closest('.botones');
        const options = buttons.find('li:not(.all)').find('input');
        options.prop('checked', target.prop('checked'));

        this._updateDownloadUrls(buttons);
    }

    private _onOptionClick(e: JQuery.ClickEvent) {
        const target = $(e.currentTarget);
        const buttons = target.closest('.botones');
        if (!target.is(":checked")) {
            buttons.find('.all').find('input').prop('checked', false);
        }

        this._updateDownloadUrls(buttons);
    }

    private _updateDownloadUrls(buttons: JQuery) {
        const selectedFiles = this._getSelectedFiles(buttons);
        const downloadSelectedButtons = buttons.find('.download_selected');

        const href = downloadSelectedButtons?.attr("href")?.split('?')[0] ?? '';

        downloadSelectedButtons.attr("href", href + selectedFiles);

        // enabled/disabled buttons
        if (selectedFiles.length) {
            downloadSelectedButtons.removeAttr("disabled");
            return;
        }

        downloadSelectedButtons.attr("disabled", "disabled");
    }

    private _getSelectedFiles(buttons: JQuery) {
        const params: Array<string> = [];

        buttons.find('input[type="checkbox"]').each(function () {
            if (!$(this).prop('checked')) {
                return;
            }
            params.push($(this).data("filter"));
        });

        return (params.length) ? `?select_files=${params.join('-')}` : '';
    }

}
